


















import { Vue, Component, Prop } from 'vue-property-decorator';
import numberFormat from '@/libs/numberFormat';
import Loader from '@/components/Loader.vue';

@Component({
  components: {
    Loader,
  },
  methods: {
    numberFormat,
  },
})
export default class BalanceBox extends Vue {
  @Prop(Number) balance!: number;
  @Prop(Boolean) loading!: boolean;

  numberFormat!: (val: number) => string;
}
